import React, { useRef, useState } from 'react';

const VideoPlayer = ({videoUrl}) => {
    const [videoReady, setVideoReady] = useState(false);
    const playerRef = useRef(null);

    return (
        <div style={{ position: 'relative', width: '100%', height: '500px' }}>
            {!videoReady ? (
                <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', cursor: 'pointer' }}>
                    <svg width="64" height="64" viewBox="0 0 64 64" onClick={() => setVideoReady(true)}>
                        <path fill="#FF0000" d="M24 41V23l16 9-16 9z"/>
                        <path fill="none" d="M0 0h64v64H0z"/>
                    </svg>
                </div>
            ) : null}
            <iframe
                width="100%"
                height="100%"
                src={videoUrl}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                ref={playerRef}
                onLoad={() => setVideoReady(true)}
            ></iframe>
        </div>
    );
};

export default VideoPlayer;
